// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.cdp-details .ant-form-item .ant-row div:first-child {
  width: 40%;
  display: flex;
}
.cdp-details .ant-form-item-has-error .ant-row .ant-col div {
  width: auto;
  display: flex;
}
.cdp-details .ant-form-item .ant-row div:last-child {
  width: auto;
  display: flex;
}
.cdp-details .ant-form-item .ant-row .ant-form-item-control-input .ant-select,
.cdp-details
  .ant-form-item
  .ant-row
  .ant-form-item-control-input
  .ant-select-selector {
  width: 100%;
}

.cdp-details .cdp-intensity .ant-form-item-label {
  height: 36px;
}

@media (max-width: 1220px) and (min-width: 760px) {
    .cdp-details .ant-form-item-label {
        text-wrap: wrap;
        height: 45px;
        overflow: visible
      }

      .cdp-details .cdp-intensity .ant-form-item-label {
        height: 45px!important;
      }
    
  
  }

  input:disabled {
    color: #000 !important;  /* Change text color */
    background-color: #f0f0f0 !important; /* Adjust background */
    opacity: 1 !important;  /* Ensure full visibility */
    cursor: not-allowed;  /* Keep the disabled cursor */
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Supplier/reporting/Cdp.css"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ;MACF;;MAEA;QACE,sBAAsB;MACxB;;;EAGJ;;EAEA;IACE,sBAAsB,GAAG,sBAAsB;IAC/C,oCAAoC,EAAE,sBAAsB;IAC5D,qBAAqB,GAAG,2BAA2B;IACnD,mBAAmB,GAAG,6BAA6B;EACrD","sourcesContent":["\n.cdp-details .ant-form-item .ant-row div:first-child {\n  width: 40%;\n  display: flex;\n}\n.cdp-details .ant-form-item-has-error .ant-row .ant-col div {\n  width: auto;\n  display: flex;\n}\n.cdp-details .ant-form-item .ant-row div:last-child {\n  width: auto;\n  display: flex;\n}\n.cdp-details .ant-form-item .ant-row .ant-form-item-control-input .ant-select,\n.cdp-details\n  .ant-form-item\n  .ant-row\n  .ant-form-item-control-input\n  .ant-select-selector {\n  width: 100%;\n}\n\n.cdp-details .cdp-intensity .ant-form-item-label {\n  height: 36px;\n}\n\n@media (max-width: 1220px) and (min-width: 760px) {\n    .cdp-details .ant-form-item-label {\n        text-wrap: wrap;\n        height: 45px;\n        overflow: visible\n      }\n\n      .cdp-details .cdp-intensity .ant-form-item-label {\n        height: 45px!important;\n      }\n    \n  \n  }\n\n  input:disabled {\n    color: #000 !important;  /* Change text color */\n    background-color: #f0f0f0 !important; /* Adjust background */\n    opacity: 1 !important;  /* Ensure full visibility */\n    cursor: not-allowed;  /* Keep the disabled cursor */\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
